import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import colors from '@theme/colors';
const useStyles = makeStyles(() => ({
  title: {
    fontSize: '22px',
    lineHeight: '36px',
    color: colors['charcoal'],
    fontWeignt: 400,
    paddingBottom: '20px',
  },
  caption: {
    fontWeight: '300 !important',
    fontSize: '16px',
    color: colors['charcoal'],
    lineHeight: '25px',
    paddingBottom: '20px',
  },
}));

export const LeadTitle = ({ title, description, subInfo }) => {
  const styles = useStyles();
  return (
    <>
      <Typography className={styles.title}>{title}</Typography>
      <Typography className={styles.caption}>{description}</Typography>
      <Typography className={styles.caption}>{subInfo}</Typography>
    </>
  );
};
